var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "new-footer" } }, [
    _c("div", {
      staticClass: "fixed-height",
      style: { height: _vm.fun.isIphoneX() ? 84 + "px" : 60 + "px" },
    }),
    _c(
      "div",
      {
        staticClass: "menu-box",
        style: { paddingBottom: _vm.fun.isIphoneX() ? 24 + "px" : 0 + "px" },
      },
      [
        _c(
          "div",
          { staticClass: "menu-list" },
          _vm._l(_vm.menuList, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "menu-item",
                on: {
                  click: function ($event) {
                    return _vm.gotoPage(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "icon" }, [
                  item.id == _vm.active
                    ? _c("img", {
                        staticClass: "active-icon",
                        attrs: { src: item.activeIcon },
                      })
                    : _c("img", {
                        staticClass: "default-icon",
                        attrs: { src: item.defaultIcon },
                      }),
                ]),
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(item.text)),
                ]),
              ]
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }